import React, { useEffect, useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Loader from '../Loader/Loader';

import { getQrCode } from './lib/generateQrCode';

/**
 * @param {import('./lib/propTypes').QrCodeProps} props
 */
const QrCode = ({
  value,
  size = 256,
  bgColor = '#FFFFFF',
  fgColor = '#000000',
  margin = 0,
  className,
  ...rest
}) => {
  const [qrUrl, setQrUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setQrUrl(null);
    setError(null);

    getQrCode({ url: value, size, bgColor, fgColor, margin, ...rest })
      .then(setQrUrl)
      .catch(setError);
  }, [value, size, bgColor, fgColor, margin, JSON.stringify(rest)]);

  const containerStyle = {
    width: size,
    height: size,
    background: bgColor,
    color: fgColor
  };

  if (error) {
    return (
      <div className="flex items-center justify-center" style={containerStyle}>
        <div className="text-center text-xs text-red-500">{error.message}</div>
      </div>
    );
  }

  if (!qrUrl) {
    return (
      <div className="flex items-center justify-center" style={containerStyle}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={cn('relative', className)} style={containerStyle}>
      <img src={qrUrl} alt="QR Code" className="h-full w-full object-contain" />
    </div>
  );
};

export default QrCode;
